export default "__VITE_ASSET__mUkS97sA__"